var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form",
    { attrs: { id: "advertiser_submit" }, on: { submit: _vm.onSubmit } },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c(
              "b-form-group",
              {
                attrs: {
                  label: "Официальное название",
                  "label-for": "legal_title"
                }
              },
              [
                _c("b-form-input", {
                  attrs: { id: "legal_title", type: "text" },
                  model: {
                    value: _vm.form.legal_title,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "legal_title", $$v)
                    },
                    expression: "form.legal_title"
                  }
                }),
                _vm._v(" "),
                _vm.$currentUser.department == "adkey"
                  ? _c("small", { staticClass: "form-text text-muted" }, [
                      _vm._v(
                        'Название рекламодателя (ЮЛ клиента) можно взять в таблице "'
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://zorkamobi.sharepoint.com/:x:/s/BlackHat/ET3Gf3QjNb5IlTbK2BdP0AoBqzNIDQ3A64H_UVpxZ87M8A?e=Da49DG",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Статус по офферам")]
                      ),
                      _vm._v('".')
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.formErrors.legal_title, function(error) {
                  return _c("span", { staticClass: "alert-danger" }, [
                    _vm._v(_vm._s(error))
                  ])
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { attrs: { label: "Бренд", "label-for": "title" } },
              [
                _c("b-form-input", {
                  attrs: { id: "title", type: "text" },
                  model: {
                    value: _vm.form.title,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "title", $$v)
                    },
                    expression: "form.title"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  label: "Регистрационный номер",
                  "label-for": "registration_number"
                }
              },
              [
                _c("b-form-input", {
                  attrs: { id: "registration_number", type: "text" },
                  model: {
                    value: _vm.form.registration_number,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "registration_number", $$v)
                    },
                    expression: "form.registration_number"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: { label: "Сейлз Менеджер", "label-for": "sales_manager" }
              },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      id: "sales_manager",
                      label: "name",
                      options: _vm.salesManagers,
                      reduce: function(manager) {
                        return manager.id
                      },
                      required: ""
                    },
                    model: {
                      value: _vm.form.sales_manager_id,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "sales_manager_id", $$v)
                      },
                      expression: "form.sales_manager_id"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.formErrors.sales_manager_id, function(error) {
                  return _c("span", { staticClass: "alert-danger" }, [
                    _vm._v(_vm._s(_vm.formErrors.sales_manager_id))
                  ])
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  label: "Аккаунт Менеджер",
                  "label-for": "account_manager"
                }
              },
              [
                _c(
                  "v-select",
                  {
                    attrs: {
                      id: "account_manager",
                      label: "name",
                      options: _vm.accountManagers,
                      reduce: function(accountManager) {
                        return accountManager.id
                      },
                      required: ""
                    },
                    model: {
                      value: _vm.form.account_manager_id,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "account_manager_id", $$v)
                      },
                      expression: "form.account_manager_id"
                    }
                  },
                  [
                    _c(
                      "span",
                      { attrs: { slot: "no-options" }, slot: "no-options" },
                      [_vm._v("Совпадений не найдено.")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.formErrors.account_manager_id, function(error) {
                  return _c("span", { staticClass: "alert-danger" }, [
                    _vm._v(_vm._s(_vm.formErrors.account_manager_id))
                  ])
                })
              ],
              2
            ),
            _vm._v(" "),
            this.$currentUser.department === "adkey"
              ? _c(
                  "b-form-group",
                  { attrs: { label: "Канал продаж" } },
                  [
                    _c("v-select", {
                      attrs: {
                        options: _vm.channels,
                        reduce: function(channel) {
                          return channel.value
                        },
                        required: "",
                        searchable: false
                      },
                      model: {
                        value: _vm.form.channel,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "channel", $$v)
                        },
                        expression: "form.channel"
                      }
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.formErrors.channel, function(error) {
                      return _c("span", { staticClass: "alert-danger" }, [
                        _vm._v("Укажите канал продаж.")
                      ])
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                attrs: {
                  label: "Дата изменения Аккаунт Менеджера",
                  "label-for": "title"
                }
              },
              [
                _c("datepicker", {
                  staticClass: "date",
                  attrs: {
                    "input-class": "form-control",
                    language: _vm.ru,
                    placeholder: ""
                  },
                  model: {
                    value: _vm.form.account_manager_change_date,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "account_manager_change_date", $$v)
                    },
                    expression: "form.account_manager_change_date"
                  }
                }),
                _vm._v(" "),
                _vm.formErrors.account_manager_change_date
                  ? _c("span", { staticClass: "alert-danger" }, [
                      _vm._v(_vm._s(_vm.formErrors.account_manager_change_date))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-dropdown",
              {
                staticClass: "float-right",
                attrs: {
                  right: "",
                  variant: "primary",
                  split: "",
                  text: "Сохранить и выйти"
                },
                on: {
                  click: function($event) {
                    return _vm.onSubmit($event, true)
                  }
                }
              },
              [
                _c(
                  "b-dropdown-item",
                  {
                    on: {
                      click: function($event) {
                        return _vm.onSubmit($event, true)
                      }
                    }
                  },
                  [_vm._v("Сохранить и выйти")]
                ),
                _vm._v(" "),
                _c(
                  "b-dropdown-item",
                  {
                    on: {
                      click: function($event) {
                        return _vm.onSubmit($event, false)
                      }
                    }
                  },
                  [_vm._v("Сохранить и создать")]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-errors" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5266d382", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5266d382","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/modals/CreateAdvertiserModal.vue
// module id = 920
// module chunks = 0